import React, { Fragment } from "react";
import { Typography, Box, Button, Link, Grid } from "@material-ui/core";
import { useStyles } from "../Theme.js";

const MentionsLegales = () => {
  const classes = useStyles();
  return (
    <Fragment>
      <Box
        className={classes.subHeader}
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "0",
        }}
      >
        <Typography
          variant="h3"
          className={classes.subHeaderTitle}
          style={{ textAlign: "center", display: "block" }}
        >
          Mentions Legales
        </Typography>
      </Box>
      <Typography variant="body2" style={{ padding: "0 30px" }}>
        <p>
          C'est une application du Conseil Départemental de l’Ariège : <br />
          Direction des affaires Européennes <br />
          Hôtel du Département 5-7 rue du Cap de la Ville <br />
          09001 FOIX Cedex
        </p>
        <h3>Contenus</h3>
        <p>
          Directeur de la publication : Conseil Départemental de l’Ariège
          <br />
          <br />
          Gestionnaire de site : Direction des affaires européennes. <br />
          <br /> ont participé à la rédaction de ce site : les équipes projet
          NATTUR des partenaires engagés sur le projet : le Conseil
          Départemental de l’Ariège, l’ADT de l’Ariège, l’Université de Girona,
          l’ISTHIA (Université Jean-Jaurès), l’Agence de Développement du
          Berguedà.
        </p>
        <h3>Conception graphique, réalisation, hébergement</h3>
        <p>
          L'application' NATTUR a été réalisée par l’agence
          <a href="https://quatrys.fr" target="_blank" rel="noreferrer">
            Quatrys
          </a>
          et développée via le Framwork Javascrip REACT JS.
        </p>
        <h3>Droits d’auteurs et copyright</h3>
        <p>
          Le site du Projet NATTUR est une œuvre de l’esprit protégée par la
          législation en vigueur. Les droits de l’auteur de ce site sont
          réservés pour toute forme d’utilisation. En particulier, la
          reproduction des éléments graphiques du site, le téléchargement
          complet du site pour son enregistrement sur un support de diffusion,
          ainsi que toute utilisation des visuels et textes qu’il contient autre
          que la consultation individuelle et privée sont interdits sans
          autorisation. Les droits afférents aux illustrations et photographies
          contenues dans ce site appartiennent, sauf mention contraire, au
          Conseil Départemental de l’Ariège.
        </p>
        <h3>Conception graphique, réalisation, hébergement</h3>
        <p>
          L'application' NATTUR a été réalisée par l’agence
          <a href="https://quatrys.fr" target="_blank" rel="noreferrer">
            Quatrys
          </a>
          et développée via le Framwork Javascrip REACT JS.
        </p>
        <h3>Crédits Photos</h3>
        <p></p>
      </Typography>
    </Fragment>
  );
};

export default MentionsLegales;
